import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* billingSubscriptionCancel({ payload: { onSuccess } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.billing.subscription.modify,
      data: {
        cancel_at_period_end: true
      }
    });

    onSuccess && onSuccess(data);
    yield put(actions.billingSubscriptionCancelDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.billingSubscriptionCancelFailed,
      endpoint: api.billing.subscription.modify.url
    });
  }
}

export const billingSubscriptionCancelSaga = takeEvery(types.BILLING_SUBSCRIPTION_CANCEL_REQUEST, billingSubscriptionCancel);
